import { Static } from './../../util/static';
import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  TextArea,
  TinyEditor,
  Control,
  DateTimePicker,
  SubForma,
  Container,
  Datos
} from '@app/shared';
import { Partial, find } from 'lodash';
import { Custom } from '../../dynamic-form/shared/controls/custom';
import { Option } from '@app/shared';
import { ModalSelect } from '@app/shared/dynamic-form';
import { CustomValidations } from '@app/shared/directives';


@Injectable()
export class RefactorDynamicFormsFormService {
  constructor() { }

  /**
   * Crea el control de pendiendo del tipo
   *
   * @param {Control} control
   * @param {*} templetesFomr
   * @param {*} value
   * @param {*} dataTemp
   * @returns {BaseControl<Partial>}
   * @memberof RefactorDynamicFormsFormService
   */
  getControl(
    control: Control,
    templetesFomr: any,
    value: any,
    dataTemp?: any,
    skipFieldGeneral: boolean = false
  ): BaseControl<Partial> {
    let field: any;
    switch (control.tipo_campo.nombre) {
      case 'textarea':
        if (!control.propiedades['usar_editor']) {
          const textArea: TextArea = new TextArea({
            key: control.nombre_campo,
            label: control.label,
            size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-' + control.espacio,
            rows: control.propiedades['rows'],
            placeholder: control.placeholder,
            tooltip: control.tooltip,
            disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
            modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
            value: '',
            order: control.orden + 1,
            condictions: control.validaciones.condiciones,
            readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
          });
          if (control.requerido) {
            textArea.validations.validators.push(Validators.required);
          }
          if (control.propiedades['max']) {
            textArea.validations.validators.push(Validators.maxLength(control.propiedades['max']));
            textArea.validations
              .messages['maxlength'] = 'El numero máximo de caracteres es de ' + control.propiedades['max'];
          }
          if (control.propiedades['min']) {
            textArea.validations.validators.push(Validators.minLength(control.propiedades['min']));
            textArea.validations
              .messages['minlength'] = 'El numero mínimo de caracteres es de ' + control.propiedades['min'];
          }
          textArea['modifiable'] = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
          field = textArea;
        } else {
          const textArea: TinyEditor = new TinyEditor({
            key: control.nombre_campo,
            label: control.label,
            size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-' + control.espacio,
            rows: control.propiedades['rows'],
            usar_editor: control.propiedades['usar_editor'],
            placeholder: control.placeholder,
            disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
            modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
            value: '',
            order: control.orden + 1,
            condictions: control.validaciones.condiciones,
            readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
          });
          if (control.requerido) {
            textArea.validations.validators.push(Validators.required);
          }
          textArea['modifiable'] = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
          field = textArea;
        }
        break;
      case 'email':
        const email: Textbox = new Textbox({
          key: control.nombre_campo,
          label: control.label,
          type: control.tipo_campo.nombre,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          tooltip: control.tooltip,
          size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-' + control.espacio,
          validations: {
            validators: [],
            messages: {}
          },
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
        });
        if (control.requerido) {
          email.validations.validators.push(Validators.required);
        }

        if (control.propiedades['expresion']) {
          email.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
          if (control.propiedades['mensajeExpresion']) {
            email.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          }
        } else {
          email.validations.validators.push(Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/));
          if (control.propiedades['mensajeExpresion']) {
            email.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          } else {
            email.validations.messages['pattern'] = 'Ingrese un email válido';
          }
        }
        email['modifiable'] = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
        field = email;
        break;
      case 'date-time-picker':
        const date: DateTimePicker = new DateTimePicker({
          key: control.nombre_campo,
          label: control.label,
          order: control.orden + 1,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
          value: null,
          size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-' + control.espacio,
          placeholder: control.placeholder,
          tooltip: control.tooltip,
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
        });
        if (control.requerido) {
          date.validations.validators.push(Validators.required);
        }

        if (control.propiedades['fechaActualDesde']) {
          const dtSince: Date = new Date();
          if (control.propiedades['tipo'] !== 'timer') {
            dtSince.setHours(0, 0, 0, 0);
          }
          date.minDate = dtSince;
          date.validations.messages['owlDateTimeMin'] = 'La fecha no puede ser menor a la fecha actual';
        } else if (control.propiedades['fechaDesde']) {
          date.minDate = control.propiedades['fechaDesde'];
          const dateString: string = new Date(control.propiedades['fechaHasta']).toLocaleDateString();
          date.validations.messages['owlDateTimeMin'] = 'La fecha no puede ser menor a ' + dateString;
        }

        if (control.propiedades['fechaActualHasta']) {
          const dtUntil: Date = new Date();
          if (control.propiedades['tipo'] !== 'timer') {
            dtUntil.setHours(0, 0, 0, 0);
          }
          date.maxDate = dtUntil;
          date.validations.messages['owlDateTimeMax'] = 'La fecha no puede ser mayor a la fecha actual';
        } else if (control.propiedades['fechaHasta']) {
          const dateString: string = new Date(control.propiedades['fechaHasta']).toLocaleDateString();
          date.maxDate = control.propiedades['fechaHasta'];
          date.validations.messages['owlDateTimeMax'] = 'La fecha no puede ser mayor a ' + dateString;
        }

        switch (control.propiedades['tipo']) {
          case 'calendar':
            date.pickerType = 'calendar';
            break;
          case 'timer':
            date.pickerType = 'timer';
            break;
          case 'range':
            date.selectMode = 'range';
            break;
          case 'rangeTime':
            date.pickerType = 'timer';
            date.selectMode = 'range';
            break;
          case 'rangeDate':
            date.pickerType = 'calendar';
            date.selectMode = 'range';
            break;
        }
        date['modifiable'] = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
        field = date;
        break;
      case 'ngSelect':
        let valueF: any = null;
        // if (control.propiedades['options'] && control.propiedades['options'].length) {
        //   for (const option of control.propiedades['options']) {
        //     if (value === option.value) {
        valueF = value;
        //       break;
        //     }
        //   }
        // }
        let ngSelect: Custom | ModalSelect;
        if ((!control.propiedades['tipoSelector'] || control.propiedades['tipoSelector'] === 'EnLista') &&
          (control.propiedades['tipo'] !== 'RadicadosSistema' && control.propiedades['tipo'] !== 'ConsecutivosActas')) {
          ngSelect = new Custom({
            key: control.nombre_campo,
            label: control.label,
            order: control.orden + 1,
            size: (
              control.propiedades['campo_interno'] ||
              (control.propiedades['columna_general'] && !skipFieldGeneral)
            ) ?
              'd-none'
              : 'col-md-' + control.espacio,
            template: templetesFomr.ngSelectTpl,
            placeholder: control.propiedades['placeholder_condicion'] ?
              control.propiedades['placeholder_condicion']
              : control.placeholder,
            tooltip: control.tooltip,
            disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
            modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
            value: valueF,
            options: control.propiedades['options'],
            validations: {
              validators: []
            },
            condictions: control.validaciones.condiciones,
            readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          });
        } else if (control.propiedades['tipo'] === 'Tramites') {
          let temp = {};
          if (control.lista_maestra && control.lista_maestra.length) {
            control.lista_maestra[0].estructura.sort((a, b) => a.orden - b.orden);
            temp = Static.copyObjet(control.lista_maestra[0]);
          }
          if (dataTemp) {
            Object.keys(dataTemp).forEach(key => {
              temp[key] = dataTemp[key];
            });
          }
          if (control.propiedades['control_acceso_maestra']) {
            temp['control_acceso_maestra'] = control.propiedades['control_acceso_maestra'];
          } else {
            temp['control_acceso_maestra'] = [];
          }
          if (control.propiedades['valores_defecto_maestra']) {
            temp['valores_defecto_maestra'] = control.propiedades['valores_defecto_maestra'];
          } else {
            temp['valores_defecto_maestra'] = [];
          }
          ngSelect = new ModalSelect({
            key: control.nombre_campo,
            label: control.label,
            order: control.orden + 1,
            size: (
              control.propiedades['campo_interno'] ||
              (control.propiedades['columna_general'] && !skipFieldGeneral)
            ) ?
              'd-none'
              : 'col-md-' + control.espacio,
            placeholder: control.propiedades['placeholder_condicion'] ?
              control.propiedades['placeholder_condicion']
              : control.placeholder,
            tooltip: control.tooltip,
            disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
            modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
            value: valueF,
            validations: {
              validators: []
            },
            condictions: control.validaciones.condiciones,
            readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            tmpParameter: temp,
            data: control ?
              control.propiedades ?
                control.propiedades['tramites'] ?
                  control.propiedades['tramites']
                  : []
                : []
              : [],
            columns: control ?
              control.propiedades ?
                control.propiedades['condictions_modal_condicion'] ?
                  control.propiedades['condictions_modal_condicion']
                  : control.propiedades['columnsSelectorModal'] ?
                    control.propiedades['columnsSelectorModal']
                    : []
                : []
              : [],
            keyValue: 'id',
            classModal: 'modal-lg-personalized',
            actionAdd: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['agregarInModal'] ?
                    control.propiedades['accionesInModal']['agregarInModal']
                    : false
                  : false
                : false
              : false,
            actionUpdate: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['modificarInModal'] ?
                    control.propiedades['accionesInModal']['modificarInModal']
                    : false
                  : false
                : false
              : false,
            actionDelete: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['eliminarInModal'] ?
                    control.propiedades['accionesInModal']['eliminarInModal']
                    : false
                  : false
                : false
              : false,
            loadData: control.propiedades && control.propiedades['loadData'] ?
              control.propiedades['loadData']
              : null,
            automaticRequest: control.propiedades && control.propiedades['loadData'] ?
              true
              : false
          });
        } else if (control.propiedades['tipo'] === 'TipoDocumental') {
          let temp = {};
          if (control.lista_maestra && control.lista_maestra.length) {
            control.lista_maestra[0].estructura.sort((a, b) => a.orden - b.orden);
            temp = Static.copyObjet(control.lista_maestra[0]);
          }
          if (dataTemp) {
            Object.keys(dataTemp).forEach(key => {
              temp[key] = dataTemp[key];
            });
          }
          if (control.propiedades['control_acceso_maestra']) {
            temp['control_acceso_maestra'] = control.propiedades['control_acceso_maestra'];
          } else {
            temp['control_acceso_maestra'] = [];
          }
          if (control.propiedades['valores_defecto_maestra']) {
            temp['valores_defecto_maestra'] = control.propiedades['valores_defecto_maestra'];
          } else {
            temp['valores_defecto_maestra'] = [];
          }
          ngSelect = new ModalSelect({
            key: control.nombre_campo,
            label: control.label,
            order: control.orden + 1,
            size: (
              control.propiedades['campo_interno'] ||
              (control.propiedades['columna_general'] && !skipFieldGeneral)
            ) ?
              'd-none'
              : 'col-md-' + control.espacio,
            placeholder: control.propiedades['placeholder_condicion'] ?
              control.propiedades['placeholder_condicion']
              : control.placeholder,
            tooltip: control.tooltip,
            disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
            modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
            value: value,
            validations: {
              validators: []
            },
            condictions: control.validaciones.condiciones,
            readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            tmpParameter: temp,
            data: control ?
              control.propiedades ?
                control.propiedades['dataSelectorModal'] ?
                  control.propiedades['dataSelectorModal']
                  : []
                : []
              : [],
            columns: [
              {
                key: 'serie',
                label: 'Serie ',
                type: 'text'
              },
              {
                key: 'subserie',
                label: 'Subserie',
                type: 'text'
              },
              {
                key: 'tipo_documental',
                label: 'Tipo documental',
                type: 'text'
              }

            ],
            keyValue: 'id',
            classModal: 'modal-lg-personalized',
            actionAdd: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['agregarInModal'] ?
                    control.propiedades['accionesInModal']['agregarInModal']
                    : false
                  : false
                : false
              : false,
            actionUpdate: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['modificarInModal'] ?
                    control.propiedades['accionesInModal']['modificarInModal']
                    : false
                  : false
                : false
              : false,
            actionDelete: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['eliminarInModal'] ?
                    control.propiedades['accionesInModal']['eliminarInModal']
                    : false
                  : false
                : false
              : false,
            loadData: control.propiedades && control.propiedades['loadData'] ?
              control.propiedades['loadData']
              : null,
            automaticRequest: control.propiedades && control.propiedades['loadData'] ?
              true
              : false
          });
        } else {
          let temp = {};
          if (control.lista_maestra && control.lista_maestra.length) {
            control.lista_maestra[0].estructura.sort((a, b) => a.orden - b.orden);
            temp = Static.copyObjet(control.lista_maestra[0]);
          }
          if (dataTemp) {
            Object.keys(dataTemp).forEach(key => {
              temp[key] = dataTemp[key];
            });
          }
          if (control.propiedades['control_acceso_maestra']) {
            temp['control_acceso_maestra'] = control.propiedades['control_acceso_maestra'];
          } else {
            temp['control_acceso_maestra'] = [];
          }
          if (control.propiedades['valores_defecto_maestra']) {
            temp['valores_defecto_maestra'] = control.propiedades['valores_defecto_maestra'];
          } else {
            temp['valores_defecto_maestra'] = [];
          }
          ngSelect = new ModalSelect({
            key: control.nombre_campo,
            label: control.label,
            order: control.orden + 1,
            size: (
              control.propiedades['campo_interno'] ||
              (control.propiedades['columna_general'] && !skipFieldGeneral)
            ) ?
              'd-none'
              : 'col-md-' + control.espacio,
            placeholder: control.propiedades['placeholder_condicion'] ?
              control.propiedades['placeholder_condicion']
              : control.placeholder,
            tooltip: control.tooltip,
            disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
            modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
            value: valueF,
            validations: {
              validators: []
            },
            condictions: control.validaciones.condiciones,
            readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            tmpParameter: temp,
            data: control ?
              control.propiedades ?
                control.propiedades['dataSelectorModal'] ?
                  control.propiedades['dataSelectorModal']
                  : []
                : []
              : [],
            columns: control ?
              control.propiedades ?
                control.propiedades['condictions_modal_condicion'] ?
                  control.propiedades['condictions_modal_condicion']
                  : control.propiedades['columnsSelectorModal'] ?
                    control.propiedades['columnsSelectorModal']
                    : []
                : []
              : [],
            keyValue: 'id',
            classModal: 'modal-lg-personalized',
            actionAdd: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['agregarInModal'] ?
                    control.propiedades['accionesInModal']['agregarInModal']
                    : false
                  : false
                : false
              : false,
            actionUpdate: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['modificarInModal'] ?
                    control.propiedades['accionesInModal']['modificarInModal']
                    : false
                  : false
                : false
              : false,
            actionDelete: control ?
              control.propiedades ?
                control.propiedades['accionesInModal'] ?
                  control.propiedades['accionesInModal']['eliminarInModal'] ?
                    control.propiedades['accionesInModal']['eliminarInModal']
                    : false
                  : false
                : false
              : false,
            loadData: control.propiedades && control.propiedades['loadData'] ?
              control.propiedades['loadData']
              : null,
            automaticRequest: control.propiedades && control.propiedades['loadData'] ?
              true
              : false
          });
        }

        if (control.requerido) {
          ngSelect.validations.validators.push(Validators.required);
        }
        ngSelect['modifiable'] = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
        ngSelect['autoAjustSize'] = control.propiedades['auto_ajustar_tamano'] ? control.propiedades['auto_ajustar_tamano'] : false;
        field = ngSelect;
        break;
      case 'number':
        const number: Textbox = new Textbox({
          key: control.nombre_campo,
          label: control.label,
          type: control.tipo_campo.nombre,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          tooltip: control.tooltip,
          size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-' + control.espacio,
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          thousandsSeparator: control.propiedades['separadorMiles'] ? control.propiedades['separadorMiles'] : null,
          decimalSeparator: control.propiedades['separadorDecimales'] ? control.propiedades['separadorDecimales'] : null
        });
        if (control.requerido) {
          number.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          if (!control.propiedades['menorQue']) {
            if (!control.propiedades['separadorMiles']) {
              number.validations.validators.push(Validators.max(control.propiedades['max']));
            } else {
              number.validations.validators.push(
                CustomValidations.customMaxEqual(
                  control.propiedades['max'],
                  control.propiedades['separadorMiles'],
                  control.propiedades['separadorDecimales']
                )
              );
            }
            number.validations.messages['max'] = 'Debe ser menor o igual a ' + control.propiedades['max'];
          } else {
            number.customMax = control.propiedades['max'];
            number.validations.messages['customMax'] = 'Debe ser menor a ' + control.propiedades['max'];
          }
        }

        if (control.propiedades['min']) {
          if (!control.propiedades['mayorQue']) {
            if (!control.propiedades['separadorMiles']) {
              number.validations.validators.push(Validators.min(control.propiedades['min']));
            } else {
              number.validations.validators.push(
                CustomValidations.customMinEqual(
                  control.propiedades['min'],
                  control.propiedades['separadorMiles'],
                  control.propiedades['separadorDecimales']
                )
              );
            }
            number.validations.messages['min'] = 'Debe ser mayor o igual a ' + control.propiedades['min'];
          } else {
            number.customMin = control.propiedades['min'];
            number.validations.messages['customMin'] = 'Debe ser mayor a ' + control.propiedades['min'];
          }
        }

        if (control.propiedades['cantidadDecimales']) {
          number.customDecimalMax = control.propiedades['cantidadDecimales'];
          number.validations.messages['customDecimalMax'] = 'Máximo ' + control.propiedades['cantidadDecimales'] +
            ' decimales permitidos';
        }

        if (!control.propiedades['enteros']) {
          if (control.propiedades['expresion']) {
            number.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
            if (control.propiedades['mensajeExpresion']) {
              number.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
            }
          }
        } else {
          number.validations.validators.push(Validators.pattern(/^-?\d+$/));
          number.validations.messages['pattern'] = 'Solo numeros enteros';
        }
        number['modifiable'] = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
        field = number;
        break;
      case 'label':
        const label: Custom = new Custom({
          key: control.nombre_campo,
          order: control.orden + 1,
          size: 'col-md-' + control.espacio,
          sizeFont: control.propiedades['sizeFont'],
          template: templetesFomr.labelTpl,
          hiddenLabel: true,
          label: control.label,
          condictions: control.validaciones.condiciones,
        });
        field = label;
        break;
      case 'coordenadas':
        const coordinates: Container = new Container({
          class: control.propiedades['campo_interno'] ? 'd-none' : 'form-row col-12',
          order: control.orden + 1,
          label: control.label,
          controls: [
            new Textbox({
              key: control.propiedades['fieldName']['latitud'],
              label: 'Latitud',
              type: 'text',
              disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
              modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
              value: value ?
                value['latitud'] ?
                  value['latitud']
                  : ''
                : '',
              placeholder: 'Latitud',
              size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-3',
              condictions: control.validaciones.condiciones,
              readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            }),
            new Textbox({
              key: control.propiedades['fieldName']['longitud'],
              label: 'Longitud',
              type: 'text',
              disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
              modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
              value: value ?
                value['longitud'] ?
                  value['longitud']
                  : ''
                : '',
              placeholder: 'Longitud',
              size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-3',
              condictions: control.validaciones.condiciones,
              readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            }),
            new Textbox({
              key: control.propiedades['fieldName']['altura'],
              label: 'Altura',
              type: 'text',
              disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
              modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
              value: value ?
                value['altura'] ?
                  value['altura']
                  : ''
                : '',
              placeholder: 'Altura',
              size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-3',
              condictions: control.validaciones.condiciones,
              readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            }),
            new Custom({
              key: control.nombre_campo + '_btn',
              order: control.orden + 1,
              size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-3',
              template: templetesFomr.buttonCordenadasTpl,
              skipDisabled: true,
              hiddenLabel: true,
              label: control.label,
              disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
              modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
              parameters: {
                nameCoordinates: control.nombre_campo,
              },
              condictions: control.validaciones.condiciones,
            }),
          ]
        });
        if (control.requerido) {
          coordinates.controls[0].validations.validators.push(Validators.required);
          coordinates.controls[1].validations.validators.push(Validators.required);
        }
        coordinates['modifiable'] = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
        field = coordinates;
        break;
      case 'checkbox':
        const checkbox: Textbox = new Textbox({
          key: control.nombre_campo,
          order: control.orden + 1,
          size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-' + control.espacio,
          type: control.tipo_campo.nombre,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
          label: control.label,
          tooltip: control.tooltip,
          condictions: control.validaciones.condiciones,
          value: value ? value : control.propiedades['default'] ? undefined : false,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
        });
        if (control.requerido) {
          checkbox.validations.validators.push(Validators.required);
          checkbox.validations.messages['required'] = 'El campo es requerido.';
        }
        if (
          control.propiedades['default'] &&
          control.propiedades['default'] === 'seleccionado' &&
          typeof value === 'undefined'
        ) {
          checkbox.default = true;
        }
        checkbox['modifiable'] = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
        field = checkbox;
        break;
      default:
        const text: Textbox = new Textbox({
          key: control.nombre_campo,
          label: control.label,
          type: control.tipo_campo.nombre,
          tooltip: control.tooltip,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          modifiable: control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false,
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          size: control.propiedades['campo_interno'] ? 'd-none' : 'col-md-' + control.espacio,
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
        });
        if (control.requerido) {
          text.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          text.validations.validators.push(Validators.maxLength(control.propiedades['max']));
          text.validations.messages['maxlength'] = 'El numero máximo de caracteres es de ' + control.propiedades['max'];
        }

        if (control.propiedades['min']) {
          text.validations.validators.push(Validators.minLength(control.propiedades['min']));
          text.validations.messages['minlength'] = 'El numero mínimo de caracteres es de ' + control.propiedades['min'];
        }

        if (control.propiedades['expresion']) {
          text.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
          if (control.propiedades['mensajeExpresion']) {
            text.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          }
        }
        text.modifiable = control.propiedades['modificar_campo'] ? control.propiedades['modificar_campo'] : false;
        field = text;
        break;
    }
    if (value !== undefined && control.tipo_campo.nombre !== 'ngSelect') {
      if (control.tipo_campo.nombre === 'date-time-picker') {
        field['value'] = new Date(value);
      } else {
        field['value'] = value;
      }
    }
    field['idInput'] = control.alias;
    return field;
  }

  /**
   * Setea el formulario dinamico creado
   *
   * @param {SubForma} form
   * @param {*} templetesForm
   * @param {Array<Datos>} data
   * @param {boolean} [update=false]
   * @returns {Promise<Array<BaseControl<Partial>>>}
   * @memberof RefactorDynamicFormsFormService
   */
  getForm(
    form: SubForma,
    templetesForm: any,
    data: Array<Datos>,
    update: boolean = false
  ): Promise<Array<BaseControl<Partial>>> {
    return new Promise((resolve, reject) => {
      const controls: BaseControl<any>[] = [new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 1,
        controls: []
      })];
      form.campos.forEach(field => {
        let value: any;
        if (!update) {
          if (data) {
            const dataField = find(data, { nombre_campo: field.nombre_campo });
            if (dataField) {
              if (field.propiedades.tipo == 'TipoDocumental') {
                value = dataField.valueSelects
              } else {
                value = dataField.valor;
              }
            }
          }
        } else {
          value = data[field.nombre_campo];
        }

        if (field.validaciones.condiciones && field.validaciones.condiciones.length) {
          field.validaciones.condiciones.forEach(condiction => {
            const campoDepende = find(form.campos, { alias: condiction.campoDepende });
            if (campoDepende) {
              condiction.campoDepende = campoDepende.nombre_campo;
            }
          });
        }
        const temp = {
          form: form,
          control: field
        };
        controls[0]['controls'].push(this.getControl(field, templetesForm, value, temp));
      });
      resolve(controls.sort((a, b) => a.order - b.order));
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/refactor-dynamic-form/shared/refactor-dynamic-forms-form.service.ts